<template>
  <ul class="sidenav app-sidenav" :class="{open: value}">
    <li>
      <div class="user-view">
        <span class="black-text name">Курс: {{courseName || 'не выбран'}}</span>
        <span class="black-text email">
          {{(typeSet==='video') ? 'Видео: ' +videoName: ''}}
          {{(typeSet==='mode') ? 'Упражнение: '+modeName : ''}}          
          <br />
          {{(typeSet==='mode') ? regimeName : ''}}
        </span>
      </div>
    </li>

    <li>
      <div class="divider"></div>
    </li>


    <router-link
      v-for="item of sideBarItemsLevel0Enabled"
      v-bind:key="item.id"
      tag="li"
      active-class="active"
      v-bind:to="item.url"
      v-bind:exact="item.exact"
    >
      <a
        href="#"
        @click="sideBarMenuOpen()"
        class="waves-effect waves-purple pointer"
      >{{item.title}}</a>
    </router-link>

    <div v-if="courseName">
      <li>
        <div class="divider"></div>
      </li>
      <router-link
        v-for="item of sideBarItemsLevel1Enabled"
        v-bind:key="item.id"
        tag="li"
        active-class="active"
        v-bind:to="item.url"
        v-bind:exact="item.exact"
      >
        <a
          href="#"
          @click="sideBarMenuOpen()"
          class="waves-effect waves-purple pointer"
        >{{item.title}}</a>
      </router-link>
    </div>

    <div v-if="typeSet">
      <li>
        <div class="divider"></div>
      </li>
      <router-link
        v-for="item of sideBarItemsLevel2Enabled"
        v-bind:key="item.id"
        tag="li"
        active-class="active"
        v-bind:to="item.url"
        v-bind:exact="item.exact"
      >
        <a
          href="#"
          @click="sideBarMenuOpen()"
          class="waves-effect waves-purple pointer"
        >{{item.title}}</a>
      </router-link>
    </div>

    <li>
      <div class="divider"></div>
    </li>

    <li class="no-padding">
      <ul class="collapsible collapsible-accordion" ref="collapsible1">
        <li>
          <a class="collapsible-header">
            Грамматика
            <i class="material-icons">arrow_drop_down</i>
          </a>
          <div class="collapsible-body">
            <ul>
              <router-link tag="li" active-class="active" to="/grammatik/verbarten">
                <a
                  href="#"
                  @click="sideBarMenuOpen()"
                  class="waves-effect waves-purple pointer font-not-bold"
                >Глагол, спряжение</a>
              </router-link>

              <router-link tag="li" active-class="active" to="/grammatik/verbzeiten">
                <a
                  href="#"
                  @click="sideBarMenuOpen()"
                  class="waves-effect waves-purple pointer font-not-bold"
                >Глагол, времена</a>
              </router-link>

              <router-link tag="li" active-class="active" to="/grammatik/verbmodus">
                <a
                  href="#"
                  @click="sideBarMenuOpen()"
                  class="waves-effect waves-purple pointer font-not-bold"
                >Глагол, модус</a>
              </router-link>

              <router-link tag="li" active-class="active" to="/grammatik/substantiv">
                <a
                  href="#"
                  @click="sideBarMenuOpen()"
                  class="waves-effect waves-purple pointer font-not-bold"
                >Существительное</a>
              </router-link>

              <router-link tag="li" active-class="active" to="/grammatik/artikel">
                <a
                  href="#"
                  @click="sideBarMenuOpen()"
                  class="waves-effect waves-purple pointer font-not-bold"
                >Артикль</a>
              </router-link>

              <router-link tag="li" active-class="active" to="/grammatik/pronomen">
                <a
                  href="#"
                  @click="sideBarMenuOpen()"
                  class="waves-effect waves-purple pointer font-not-bold"
                >Местоимение</a>
              </router-link>

              <router-link tag="li" active-class="active" to="/grammatik/adjektiv">
                <a
                  href="#"
                  @click="sideBarMenuOpen()"
                  class="waves-effect waves-purple pointer font-not-bold"
                >Прилагательное</a>
              </router-link>

              <router-link tag="li" active-class="active" to="/grammatik/adverb">
                <a
                  href="#"
                  @click="sideBarMenuOpen()"
                  class="waves-effect waves-purple pointer font-not-bold"
                >Наречие</a>
              </router-link>

              <router-link tag="li" active-class="active" to="/grammatik/praeposition">
                <a
                  href="#"
                  @click="sideBarMenuOpen()"
                  class="waves-effect waves-purple pointer font-not-bold"
                >Предлог</a>
              </router-link>

              <router-link tag="li" active-class="active" to="/grammatik/konjunktion">
                <a
                  href="#"
                  @click="sideBarMenuOpen()"
                  class="waves-effect waves-purple pointer font-not-bold"
                >Союз</a>
              </router-link>

              <router-link tag="li" active-class="active" to="/grammatik/satzbau">
                <a
                  href="#"
                  @click="sideBarMenuOpen()"
                  class="waves-effect waves-purple pointer font-not-bold"
                >Порядок слов</a>
              </router-link>
            </ul>
          </div>
        </li>
      </ul>
    </li>

    <li>
      <div class="divider"></div>
    </li>

  </ul>
</template>

<style scoped>
.divider {  
  background-color: black;
}

.app-sidenav.open {    
    background-color: #e8eaf6 ;
}

.sidenav .user-view {
    padding: 0px 5px 0px 5px;
}

.sidenav .collapsible-body > ul:not(.collapsible) > li.active {
  color: white;
  background-color: #ee6e73;
}
.sidenav li.active > a {
  color: white;
  background-color: #ee6e73;
}
.font-not-bold {
  font-weight: normal;
}
</style>

<script>
export default {
  props: ["value"],
  data: () => ({
    collapsible1: null
  }),
  computed: {
    courseName() {
      return this.$store.getters.course.name;
    },
    videoName() {
      return this.$store.getters.video.name;
    },
    modeName() {
      return this.$store.getters.mode.name;
    },
    regimeName() {
      switch (this.$store.getters.idMode0) {
        case "Hor-0":
          return "Hören(Слушаем)";
        case "Sp-0":
          return "Sprechen (Говорим)";
        case "Sch-0":
          return "Schreiben (Пишем)";
      }
      return null;
    },
    typeSet() {
      return this.$store.getters.typeSet;
    },
    sideBarItemsLevel0Enabled() {
      return this.$store.getters.sideBarItems.filter(
        item => item.enabled && item.level == 0
      );
    },
    sideBarItemsLevel1Enabled() {
      return this.$store.getters.sideBarItems.filter(
        item => item.enabled && item.level == 1
      );
    },
    sideBarItemsLevel2Enabled() {
      return this.$store.getters.sideBarItems.filter(
        item => item.enabled && item.level == 2 && item.type === this.typeSet
      );
    }
  },
  mounted() {
    this.collapsible1 = M.Collapsible.init(this.$refs.collapsible1);
  },
  beforeDestroy() {
    if (this.collapsible1 && this.collapsible1.destroy) {
      this.collapsible1.destroy();
    }
  },
  methods: {
    sideBarMenuOpen() {
      this.collapsible1.close(0);
      this.$emit("clickSideBarMenu1");
    }
  }
};
</script>



